import { render, staticRenderFns } from "./ScoreForm.vue?vue&type=template&id=7dd0506e&"
import script from "./ScoreForm.vue?vue&type=script&lang=js&"
export * from "./ScoreForm.vue?vue&type=script&lang=js&"
import style0 from "./ScoreForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports